import * as R from 'remeda';

export default function excludeFalseyValues(obj: Record<string, unknown> = {}) {
  return R.pipe(
    obj,
    R.toPairs,
    R.reject(([_, value]) => !R.isTruthy(value)),
    R.fromPairs
  );
}
